<template>
    <div class="sub-page">
        <div class="main_section">
            <div class="section_item feature-block">
                <h2 class="title">{{featureTitle}}</h2>
                <div class="center">
                    <Company :company="companyStyle"></Company>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import getLang from '@/utils/main/language';
import Layout from '@/views/Layout.vue';
import Company from '@/views/corp/Company';
import ajax from '@/utils/ajax';
import router from '@/router';

export default {
    name: 'corpFeature',
    components: {
        Layout,
        Company,
    },
    data() {
        return {
            isCn: window.localStorage.getItem('show-lang') !== 'en',
            lang: getLang(),
            companyStyle: '',
            featureTitle: '',
        };
    },
    mounted() {
        ajax.get('/web/homepage/homepage_list.json', { }).then((result) => {
            this.homeList = result.dataList;
            result.dataList.forEach((item) => {
                if (item.type === 'companyStyle') {
                    try {
                        const companyStyle = JSON.parse(item.jsonStr);
                        this.companyStyle = companyStyle;
                        this.featureTitle = this.isCn ? companyStyle.titleCn : companyStyle.titleEn;
                    } catch (error) {
                        console.log('JSON ERROR');
                    }
                }
            });
        }).catch(() => {});
    },
    methods: {
        goBack() {
            router.go(-1);
        },
    },
};
</script>
<style lang="less" scoped>
    .main_section{
        border-top: 8px solid #F8FAF9;
        width: 100%;
        height: auto;
        .section_item{
            width: 100%;
            height: auto;
            &:nth-child(even){
                background:rgba(248,250,249,1);
            }
            .title{
                padding-top: 40px;
                font-size: 20px;
                font-weight: 600;
                color: rgba(74,74,74,1);
                line-height: 20px;
                text-align: center;
                position: relative;
                &::after{
                    content:"";
                    width:44px;
                    height:4px;
                    background:rgba(199,31,75,1);
                    position: absolute;
                    bottom: -12px;
                    left: 50%;
                    margin-left: -22px;
                }
            }
        }
    }
    .center {
        margin: 0 auto;
        width: 960px;
        padding: 24px 0 40px;
        display: flex;
        justify-content: space-between;
    }
</style>
